import { useContext } from 'react';

import { ReservationLocalstorageSteps } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';
import { localStorageValuesFromFirstStep } from 'modules/accommodations/features/reservations/helper';
import { useTransitionInStepsTransformedTableData } from 'modules/accommodations/features/reservations/hooks';
import { ReservationNewContext } from 'modules/accommodations/features/reservations/routes/ReservationNewContext';

export const useInitialValuesDiscountTransformData = (rowIndex: number) => {
  const { thirdStepTableState } = useContext(ReservationNewContext);
  const { servicesTableData, discountsTableData, isDiscountSideBarOpen } = thirdStepTableState;

  const localstorageFirstStep = JSON.parse(
    localStorage.getItem(ReservationLocalstorageSteps.FIRSTSTEP) as string,
  );
  const { from, to, numberOfGuestsSum } = localStorageValuesFromFirstStep(localstorageFirstStep);

  const { transformedDiscountsDataForAPI } = useTransitionInStepsTransformedTableData(
    servicesTableData,
    discountsTableData,
    from,
    to,
    numberOfGuestsSum,
    isDiscountSideBarOpen,
  );

  //initial values
  if (!transformedDiscountsDataForAPI[rowIndex]) {
    return {
      serviceId: 2,
      reservationDiscountType: '',
      amountPerDiscountType: '',
      applyDiscountPriceTo: '',
    };
  }

  return transformedDiscountsDataForAPI[rowIndex];
};
